!function () {
    "use strict";
    var e = {
        6072: function (e, t, n) {
            function i(e, t) {
                let n, i = null;
                const r = () => {
                    null == n ? i = null : (e(...n), n = null, setTimeout(r, t))
                };
                return function () {
                    for (var s = arguments.length, l = new Array(s), a = 0; a < s; a++) l[a] = arguments[a];
                    i ? n = l : (e(...l), i = setTimeout(r, t))
                }
            }

            n.d(t, {
                KN: function () {
                    return r
                }, dU: function () {
                    return s
                }, mk: function () {
                    return i
                }
            }), document.querySelectorAll(".local-scroll").forEach((e => {
                e.addEventListener("click", (e => {
                    e.preventDefault(), e.stopPropagation();
                    const t = e.target.getAttribute("href");
                    !function (e) {
                        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                        const n = document.getElementById("nav-wrapper"),
                          i = document.querySelector(".header").getAttribute("data-ux-position"),
                          r = e.getBoundingClientRect().top;
                        window.scrollTo({
                            top: "off" !== i ? r + window.scrollY - t + parseFloat(n.style.marginTop) : r + window.scrollY - t,
                            behavior: "smooth"
                        })
                    }(document.querySelector(t))
                }))
            }));
            const r = e => {
                let t = window.innerWidth;
                const n = () => {
                    window.innerWidth !== t && (e(), t = window.innerWidth)
                };
                e._resizeHandler = n, window.addEventListener("resize", n)
            }, s = e => {
                e._resizeHandler && (window.removeEventListener("resize", e._resizeHandler), delete e._resizeHandler)
            }
        }
    }, t = {};

    function n(i) {
        var r = t[i];
        if (void 0 !== r) return r.exports;
        var s = t[i] = {exports: {}};
        return e[i](s, s.exports, n), s.exports
    }

    n.d = function (e, t) {
        for (var i in t) n.o(t, i) && !n.o(e, i) && Object.defineProperty(e, i, {enumerable: !0, get: t[i]})
    }, n.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t)
    }, function () {
        var e = n(6072);

        class t extends HTMLElement {
            constructor() {
                super(), this.throttleHandleRenderLogic = (0, e.mk)(this.handleRenderLogic.bind(this), 250), this.expandClickHandler = this.expandClickHandler.bind(this), this.shrinkClickHandler = this.shrinkClickHandler.bind(this)

            }

            connectedCallback() {
                this.truncatable = this.querySelector(".truncatable-content"), this.expand = this.querySelector(".expand"), this.shrink = this.querySelector(".shrink"), this.truncatable && this.expand && this.shrink && (this.handleRenderLogic(), (0, e.KN)(this.throttleHandleRenderLogic))
                this.truncatable.style.maxHeight = this.truncatable.scrollHeight + "px", this.classList.add("expanded")
            }

            handleRenderLogic() {
                this.truncatable.offsetHeight < this.truncatable.scrollHeight || this.truncatable.offsetWidth < this.truncatable.scrollWidth ? (this.classList.contains("expanded") && (this.truncatable.style.maxHeight = this.truncatable.scrollHeight + "px"), this.renderExpandShrink()) : this.removeExpandShrink()
            }

            expandClickHandler(e) {
                e.preventDefault(), e.stopPropagation(), this.truncatable.style.maxHeight = this.truncatable.scrollHeight + "px", this.classList.add("expanded")
                console.log('this.truncatable',this.truncatable)
                const icon = document.getElementById('toggleIcon');

                icon.addEventListener('click', () => {
                    icon.classList.toggle('line-vertical');
                });
            }

            shrinkClickHandler(e) {
                e.preventDefault(), e.stopPropagation(), this.truncatable.style.maxHeight = null, this.classList.remove("expanded")
            }

            renderExpandShrink() {
                this.classList.add("truncated"), this.expand.addEventListener("click", this.expandClickHandler), this.shrink.addEventListener("click", this.shrinkClickHandler)
            }

            removeExpandShrink() {
                this.classList.remove("truncated"), this.expand.removeEventListener("click", this.expandClickHandler), this.shrink.removeEventListener("click", this.shrinkClickHandler)
            }

            disconnectedCallback() {
                (0, e.dU)(this.throttleHandleRenderLogic)
            }
        }

        customElements.get("truncatable-content") || customElements.define("truncatable-content", t)
    }()
}();
